module.exports = __webpack_public_path__ + "img/arrow.14178a62.svg";